import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { registerAccessTokenGetter } from "auth/accessToken";

/**
 * Registra `getAccessTokenSilently` de Auth0 en el módulo `accessToken`, para
 * que los clientes de CubeJS puedan pedir un token vigente en cada request en
 * lugar de usar la copia que quedó guardada al montar la app.
 *
 * Solo lo registra **cuando hay sesión**. Sin sesión, `getAccessTokenSilently`
 * no falla rápido: dispara un silent-auth por iframe que nadie contesta y
 * espera los 60s del timeout del SDK. Con el getter sin registrar,
 * `getAccessToken()` devuelve `undefined` en el acto.
 *
 * No renderiza nada. Debe montarse una sola vez dentro del `Auth0Provider`, y
 * antes del árbol que consulta CubeJS para que su efecto corra primero.
 */
const AccessTokenRegistrar = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  useEffect(() => {
    registerAccessTokenGetter(isAuthenticated ? getAccessTokenSilently : null);
  }, [isAuthenticated, getAccessTokenSilently]);

  return null;
};

export default AccessTokenRegistrar;
